<div class="link-expired-wrapper">
    <div class="back-button-container">
        <button class="btn-back" (click)="onBackClick()">
            <i class="bi bi-chevron-left"></i>
            {{ 'LINK_EXPIRED.BACK' | translate }}
        </button>
    </div>

    <div class="content">
        <h1 class="title">{{ 'LINK_EXPIRED.TITLE' | translate }}</h1>
        <p class="message">{{ 'LINK_EXPIRED.MESSAGE' | translate }}</p>
    </div>
</div>